/*!

 =========================================================
 * Vue Now UI Dashboard PRO - v1.1.1
 =========================================================

 * Product Page: http://www.creative-tim.com/product/now-ui-dashboard
 * Copyright 2019 Creative Tim (http://www.creative-tim.com)

 * Designed by www.invisionapp.com Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */

import Vue from 'vue';
import axios from "axios";
import DashboardPlugin from './dashboard-plugin';

// Plugins
import App from './App.vue';
import vuetify from '@/plugins/vuetify';
import VueAxios from "vue-axios";
import IsDemo from "./components/isDemo"
import VueMeta from 'vue-meta';
import VuePapaParse from 'vue-papa-parse'
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin';

// import "./assets/css/demo.css";
// import 'vuetify/dist/vuetify.min.css'

// router setup
import routes from './routes';
import store from "./store";

// plugin setup
//Vue.use(vuetify);
Vue.use(DashboardPlugin);
Vue.use(VueAxios, axios);
Vue.use(IsDemo);
Vue.use(VueMeta, { keyName: 'head' });
Vue.use(VuePapaParse);
Vue.use(VueCookieBot, {
  cookieBotID: '07c2f27f-4abd-4ad0-a890-5702966897b6'
})


/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  vuetify,
  render: h => h(App),
  router: routes,
  store:store
});

store.$app = app;

